module.exports = __webpack_public_path__ + "static/img/search.d9fe0922.png";